import React, { ReactNode } from "react";

import { CreatedObject } from "./Create/CreatedObject";
import { DeletedObject } from "./Delete/DeletedObject";
import { UpdatedKeyValueLine } from "./Update/UpdatedKeyValueLine";
import { UpdatedObject } from "./Update/UpdatedObject";
import { NestedObject } from "./NestedObject";
import { ChangeLogProps, KEYS_TO_IGNORE } from "./utils";

export const Event = ({
  k,
  value,
  key,
}: ChangeLogProps): { type: string; element: ReactNode } => {
  if (KEYS_TO_IGNORE.includes(k)) {
    return {
      type: "default",
      element: <></>,
    };
  }
  if (
    value.type === "updated" &&
    value.data &&
    typeof value.data === "object" &&
    "from" in value.data &&
    "to" in value.data &&
    typeof value.data.from !== "object" &&
    typeof value.data.to !== "object"
  ) {
    return {
      type: "updatedKeyValueLine",
      element: <UpdatedKeyValueLine k={k} value={value} key={k} />,
    };
  }

  if (value && typeof value === "object" && "type" in value) {
    if (value.type === "created") {
      return {
        type: "createdObject",
        element: <CreatedObject to={value.data.to} k={k} key={key} />,
      };
    }
    if (value.type === "deleted") {
      return {
        type: "deletedObject",
        element: <DeletedObject from={value.data.from} k={k} key={key} />,
      };
    }
    return {
      type: "updatedObject",
      element: <UpdatedKeyValueLine value={value} k={k} key={key} />,
    };
  }
  return {
    type: "nestedObject",
    element: <NestedObject k={k} value={value} />,
  };
};
